import {match} from 'ts-pattern';

import {Navigate} from 'react-router-dom';

import {settingsRoutes} from '@dms/routes';

import {useRequiredParams} from 'shared/web';

import {CreateMessageTemplateForm} from './CreateMessageTemplateForm';

export const MessageTemplateNew = () => {
  const {type} = useRequiredParams();
  return match(type)
    .with('email', 'sms', 'chat', (type) => <CreateMessageTemplateForm templateType={type} />)
    .otherwise(() => <Navigate to={settingsRoutes.messageTemplates} />);
};
